<div class="mt-3 test-case-wrapper h-100 container-fluid">
  <div class="d-flex flex-column w-100">
    <!-- Left Side: Form -->
    <form
      [formGroup]="form"
      class="d-flex align-items-center flex-grow-1"
      (ngSubmit)="onSubmitVersionHistory()"
    >
      <formly-form
        [form]="form"
        [fields]="[
          versionHistoryField[0],
          versionHistoryField[1],
          versionHistoryField[2]
        ]"
        [model]="versionHistoryModel"
        [options]="options"
        (modelChange)="onSubmitVersionHistory()"
        class="w-100"
      >
      </formly-form>
    </form>

    <!-- Right Side: Buttons -->
    <div class="d-flex align-items-center mb-2 pt-2 accello-border-top">

      <span class="flex-grow-1 general-text-2">
       Test Cases Count :  ({{selectedTestCaseCount}}) 
      </span>

      <button [hidden]="true"
        class="btn-accello-primary btn-accello mx-2"
        [disabled]="!selectedRow?.length || restStatus.save"
        type="submit"
        (click)="saveTestCases(selectedRow)"
      >
        <span>
          <img src="assets/images/virtusa-icons/save.svg" alt="save">
        </span>
        Save
      </button>

      <button
        class="btn-accello-secondary btn-accello "
        type="button"
        [disabled]="!(tableData.data | async)?.length"
        (click)="addMissingTestCases()"
      >
        <span>
          <img src="assets/images/virtusa-icons/add-icon.svg" alt="add">
        </span>
        Add Missing Test cases
      </button>

      <button
        class="btn-accello-secondary btn-accello mx-2"
        [disabled]="!selectedRow?.length || restStatus.delete"
        type="submit"
        (click)="deleteTestCases()"
      >
        <span>
          <img src="assets/images/virtusa-icons/remove.png" alt="remove">
        </span>
        Remove Test Cases
      </button>

      <button
        class="btn-accello-secondary btn-accello"
        type="button"
        (click)="onDownload()"
        [disabled]="!selectedRow?.length"
      >
        <span>
          <img
            [src]="'assets/images/virtusa-icons/chat-download-purple.svg' | assetUrl"
            alt="Excel"
            class="excel-download"
          />
        </span>
        Download
      </button>
    </div>
  </div>

  <div class="table-wrapper h-100 mt-2">
    <div
      class="h-100 d-flex justify-content-center align-items-center"
      *ngIf="loading$ | async"
    >
      <app-loading [text]="'Loading data'"></app-loading>
    </div>

    @if(!(loadingTestCases$ | async) && !(loading$ | async)) {
    <ng-container *ngIf="tableConfigs?.rows?.length; else noDataTemplate">
      <app-test-case-table
        class="w-100"
        [configs]="tableConfigs"
        (onRowSelect)="handleRowSelection($event)"
        (handleActions)="handleSidePanelActions($event)"
        (pageChange)="onPageChange($event)"
        ></app-test-case-table>
      <!-- <app-zorro-table
        class="w-100"
        [columns]="tableData.columns"
        [data]="responseData"
        (handleActions)="onTableActinChange($event)"
        (onRowSelect)="handleRowSelection($event)"
      ></app-zorro-table> -->
    </ng-container>
    <ng-template #noDataTemplate>
      <ng-container *ngIf="!(tableData.data | async)?.length">
        <app-no-data></app-no-data>
      </ng-container>
    </ng-template>
    } 
    
    @else if( !(loading$ | async)) {
    <app-loading [text]="'Loading data'"></app-loading>
    }
  </div>
</div>
